
import { usePermissions } from '@/contexts/unified-permissions';

export const useSubscriptionPayment = () => {
  const { upgradeInProgress, initiateSubscription } = usePermissions();

  return {
    upgradeInProgress,
    initiateSubscription
  };
};
